import {
  Divider,
  Flex,
  HStack,
  Text,
  useDisclosure,
  useToast,
  Stack,
} from "@chakra-ui/react";
import { ReactComponent as LeftIcon } from "../../assets/chevron-left.svg";
import { ReactComponent as CalendarImage } from "../../assets/calendar.svg";
import { ReactComponent as AlertTriangle } from "../../assets/alert-triangle.svg";
import React, { useEffect, useState } from "react";
import { ReactComponent as RightIcon } from "../../assets/chevron-right.svg";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../BookingConfirmed/confirm.css";
import useLegacyIframeResizeMessage from "../../hooks/useLegacyIframeResizeMessage";
import CustomButton from "../../Components/Button/CustomButton";
import Heading from "../../Components/Text/heading";
import SidePanel from "../../Components/SidePanel/SidePanel";
import LargeContainer from "../../Components/Container/largeContainer";
import dayLabels from "../../data/dayLabels.json";
import SmallFlexContainer from "../../Components/Container/smallFlexContainer";
import Calendar from "../../Components/Calendar/calendar";
import SubHeading from "../../Components/Text/subHeading";
import Slots from "../../Components/Slots/Slots";
import {
  deleteBooking,
  existingBookingSearch,
  getMonthlyData,
  searchForBooking,
} from "../../bookingapi/booking.operations";
import { getDailyRecords } from "../../utils/DailyRecords";
import Form from "../../Components/Forms/Form";
import BookingDateForm from "../../Components/Forms/BookingDateForm";
import { validateMaxDate } from "../AddBooking/AddBooking";
import LoadingScreen from "../../Components/LoadingScreen/LoadingScreen";
import { maxBookingDate } from "../../utils/MaxBookingDate";
import PopUp from "../../Components/PopUp/PopUp";

export default function UpdateBooking() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const navigate = useNavigate();
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const [bookingId, setBookingId] = useState();
  const [isAmend, setIsAmend] = useState(false);
  const [calendarDate, setCalendarDate] = useState(today);
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [bookingNotFound, setBookingNotFound] = useState(false);
  const [monthlyData, setMonthlyData] = useState({});
  const [dailyData, setDailyData] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState({});
  const [originalBooking, setOriginalBooking] = useState({});
  const [currentBookingDate, setCurrentBookingDate] = useState();
  const [loader, setLoader] = useState(true);
  const [isSameAppointmentOpen, setIsSameAppointmentOpen] = useState(false);

  const toast = useToast();
  useLegacyIframeResizeMessage([isAmend]);

  const { maxDate, customerId, phoneNumber } = location?.state || {};
  const [maxGlobalDate, setMaxGlobalDate] = useState(maxDate);

  const invalidMaxDate = validateMaxDate(maxGlobalDate);

  useEffect(() => {
    const searchBooking = async () => {
      try {
        let booking = null;
        let tokenBooking = null;
        let bookingData = {};
        if (token) {
          tokenBooking = await searchForBooking(token);
          bookingData = tokenBooking;
        } else {
          booking = await existingBookingSearch(customerId, phoneNumber);
          bookingData = booking[0];
        }

        if (!bookingData || bookingData.length === 0) {
          setBookingNotFound(true);
          return;
        }

        setBookingNotFound(false);
        setOriginalBooking(bookingData);

        if (!maxDate) {
          const bookingDate = await maxBookingDate(bookingData.customerId);
          setMaxGlobalDate(bookingDate);
        }

        const timestamp = bookingData.dayId?.date; // timestamp value in milliseconds
        const formattedDate = new Date(timestamp);
        setCurrentBookingDate(formattedDate);
        setSelectedSlot(bookingData.timeSlotId);
        setBookingId(bookingData.bookingId);

        if (formattedDate < yesterday) {
          navigate("/add-booking", {
            state: {
              customerId: bookingData.customerId,
              customerFirstName: bookingData.customerFirstName,
              customerLastName: bookingData.customerLastName,
              phoneNumber: bookingData.phoneNumber,
              maxDate,
              overwriteExistingBooking: true,
              bookingId,
              existingBookingToken: originalBooking.token,
            },
          });
        }
      } catch (error) {
        console.log(error.message);
        setBookingNotFound(true);
      }
    };
    searchBooking();
  }, [token, customerId, phoneNumber, maxDate]);

  useEffect(() => {
    const monthlyData = async () => {
      const year = calendarDate.getFullYear();
      const month = calendarDate.getMonth() + 1;

      try {
        const data = await getMonthlyData(year, month);
        setMonthlyData(data);
      } catch (err) {
        console.log(err);
      } finally {
        setLoader(false);
      }
    };
    monthlyData();
  }, [calendarDate]);

  useEffect(() => {
    if (selectedDate) {
      const year = selectedDate.getFullYear();
      const month = selectedDate.getMonth() + 1; // Add 1 to get the month number starting from 1 instead of 0
      const day = selectedDate.getDate();

      getDailyRecords(day, month, year, setDailyData);
    }
  }, [selectedDate]);

  const updateBooking = async (event) => {
    setLoading(true);
    if (
      !originalBooking.customerFirstName ||
      originalBooking.customerFirstName === ""
    ) {
      alert("Invalid First Name");
      return;
    }

    if (
      !originalBooking.customerLastName ||
      originalBooking.customerLastName === ""
    ) {
      alert("Invalid Last Name");
      return;
    }

    if (!bookingId || bookingId === "" || bookingId < 0) {
      alert("Invalid Customer ID");
      return;
    }

    if (!selectedDate || selectedDate === "") {
      alert("Please select a date");
    }

    if (!selectedSlot || selectedSlot === "") {
      alert("Please select a slot");
    }

    const isSameSlot =
      selectedSlot.timeSlotId === originalBooking.timeSlotId.timeSlotId;

    const formattedOriginalBookingDate = new Date(originalBooking.dayId.date);
    const isSameDate =
      selectedDate.toDateString() ===
      formattedOriginalBookingDate.toDateString();

    if (isSameSlot && isSameDate) {
      setIsSameAppointmentOpen(true);
      setLoading(false);
      return;
    }

    try {
      let body = {
        timeSlotId: selectedSlot.timeSlotId,
        year: selectedDate.getFullYear(),
        month: selectedDate.getMonth() + 1,
        day: selectedDate.getDate(),
        token: token || originalBooking.token,
      };

      const response = await axios.put(
        `${process.env.REACT_APP_BOOKING_ADMIN_URL}/booking/updateBooking/${bookingId}`,
        body,
        {
          headers: {
            api_key: process.env.REACT_APP_BOOKING_ADMIN_API_KEY,
          },
        }
      );
      setLoading(false);
      if (response.data === "Slot not found") {
        alert("Booking already found");
        return;
      }

      if (response.data === "Booking already found") {
        alert("Booking already found");
        return;
      }

      const year = selectedDate.getFullYear();
      const month = selectedDate.getMonth() + 1; // Add 1 to get the month number starting from 1 instead of 0
      const day = selectedDate.getDate();

      getMonthlyData();
      getDailyRecords(day, month, year);

      toast({
        title: "Booking Updated.",
        description: "Your Booking has been updated",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      // Fire the event to parent window after the booking has been completed
      if (window.parent) {
        window.parent.postMessage(
          {
            type: "BOOKING_SYSTEM_EVENT",
            data: "COMPLETE",
          },
          "*"
        );
      }
      setSelectedSlot("");
      setBookingId("");
      navigate("/booking-confirmed", {
        state: { selectedSlot, selectedDate },
      });
      setIsAmend(false);
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    }
  };

  const handleDelete = async (event) => {
    try {
      await deleteBooking(bookingId);

      onClose();
      setBookingNotFound(true);
      navigate("/", { replace: true });
      toast({
        title: "Booking Deleted.",
        description: "Your Booking has been deleted",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      setSelectedSlot("");
      setBookingId("");

      // Fire the event to parent window after the booking has been completed
      if (window.parent) {
        window.parent.postMessage(
          {
            type: "BOOKING_SYSTEM_EVENT",
            data: "COMPLETE",
          },
          "*"
        );
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    }
  };

  function getAvailableSlotsForDay(day) {
    // Find the corresponding day data in the monthlyData array
    const dayData = monthlyData?.find((d) => d.date[2] === day);
    // If dayData exists, return the availableSlots, otherwise return 0
    const slots = dayData ? dayData?.availableSlots - dayData?.bookedSlots : 0;
    // given customer visibile app, mask possible negative slots.
    return slots > 0 ? slots : 0;
  }

  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  function subtractMonth() {
    setCalendarDate(
      new Date(calendarDate.setMonth(calendarDate.getMonth() - 1))
    );
  }
  function addMonth() {
    setCalendarDate(
      new Date(calendarDate.setMonth(calendarDate.getMonth() + 1))
    );
  }

  function renderDays() {
    // Get today's date
    let today = new Date();
    // Make sure to set the time to midnight for a fair comparison
    today.setHours(0, 0, 0, 0);

    return (
      <>
        {loader ? (
          <LoadingScreen
            loadingText={"Hold tight"}
            loadingSubText={"It will just take a few moments"}
          />
        ) : (
          <Calendar
            getAvailableSlotsForDay={getAvailableSlotsForDay}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            calendarDate={calendarDate}
            maxGlobalDate={maxGlobalDate}
          />
        )}
      </>
    );
  }

  if (bookingNotFound) {
    return (
      <LargeContainer h="100vh">
        <Stack bg="white" p="32px" rounded={5} boxShadow="lg">
          <Stack spacing="20x" className={styles.referrerBookingConfirmed}>
            <div className={styles.inputFieldsearch}></div>

            <div className={styles.iconscheckCircleParent}>
              <AlertTriangle />
              <div className={styles.bookingConfirmedParent}>
                <b className={styles.bookingConfirmed}>
                  Unable to find your booking
                </b>
                <div style={{ width: "50vw" }}></div>
              </div>
            </div>
          </Stack>
        </Stack>
      </LargeContainer>
    );
  }

  const formattedDate = ` ${calendarDate.toLocaleString("default", {
    month: "long",
  })} ${calendarDate.getFullYear()}`;

  return (
    <LargeContainer padding="5px" minHeight="100vh">
      <SmallFlexContainer px={{ base: "5%", md: "15%" }}>
        <SmallFlexContainer
          py={"20px"}
          justifyContent="space-between"
          flexDirection={{ base: "column", md: "row" }}
        >
          {isSameAppointmentOpen && (
            <PopUp
              popUpHeading={"Selected same date and time as original booking"}
              popUpMessage={
                "Please amend the booking with a different date or time."
              }
              isOpen={isSameAppointmentOpen}
              onClose={() => setIsSameAppointmentOpen(false)}
            />
          )}
          {bookingId && bookingId !== "" && (
            <>
              {isAmend ? (
                <>
                  <SmallFlexContainer
                    width={{ base: "100%", md: "49.14%" }}
                    backgroundColor={"#FFFFFF"}
                    alignItems={"center"}
                  >
                    <Form formData={originalBooking} disabled></Form>

                    {invalidMaxDate ? (
                      <SmallFlexContainer
                        alignItems={"center"}
                        marginTop={"60px"}
                      >
                        <Text>No Dates Available!</Text>
                      </SmallFlexContainer>
                    ) : (
                      <Flex width={"92.92%"} justifyContent={"center"}>
                        <Flex width={"100%"} flexDirection={"column"}>
                          <Flex width={"100%"} minheight={"80px"}>
                            <Flex marginTop={"27px"}>
                              <LeftIcon
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={subtractMonth}
                              />
                              &nbsp;
                              <RightIcon
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={addMonth}
                              />
                            </Flex>
                            <Heading headingLabel={formattedDate}></Heading>
                          </Flex>
                          <HStack spacing="1.26%" marginTop={"16px"}>
                            {dayLabels.map((day, index) => (
                              <SubHeading
                                key={index}
                                textAlign={"center"}
                                w="13.2%"
                                h="16px"
                                subHeadingLabel={day.abbreviation}
                              ></SubHeading>
                            ))}
                          </HStack>
                          <Flex marginTop={"8px"} marginBottom="16px">
                            {renderDays()}
                          </Flex>
                        </Flex>
                      </Flex>
                    )}
                  </SmallFlexContainer>

                  <SmallFlexContainer
                    width={{ base: "100%", md: "49.14%" }}
                    mt={{ base: "20px", md: "0px" }}
                    backgroundColor={"#FFFFFF"}
                    alignItems={"center"}
                  >
                    <SmallFlexContainer width={"92.92%"}>
                      <Heading headingLabel="Choose your time slot"></Heading>
                      {invalidMaxDate ? (
                        <SmallFlexContainer
                          alignItems="center"
                          marginTop={"30px"}
                        >
                          <Text>No Time Slots Available!</Text>
                        </SmallFlexContainer>
                      ) : (
                        <Slots
                          dailyData={dailyData}
                          selectedSlot={selectedSlot}
                          setSelectedSlot={setSelectedSlot}
                          selectedDate={selectedDate}
                        ></Slots>
                      )}
                    </SmallFlexContainer>
                    <SmallFlexContainer minHeight={"104px"}>
                      <Divider />

                      {!invalidMaxDate && selectedDate && (
                        <CustomButton
                          marginTop={"16px"}
                          onClick={updateBooking}
                          _hover={{
                            background: "blue.800",
                          }}
                          buttonLabel="Amend Booking"
                          isDisabled={loading}
                          isLoading={loading}
                        ></CustomButton>
                      )}
                      {selectedDate && (
                        <CustomButton
                          ref={btnRef}
                          onClick={onOpen}
                          marginTop={"16px"}
                          backgroundColor={"#00E0FF"}
                          buttonLabel="Delete Booking"
                          marginBottom={"16px"}
                        ></CustomButton>
                      )}
                    </SmallFlexContainer>
                  </SmallFlexContainer>
                </>
              ) : (
                <SmallFlexContainer
                  justifyContent="space-between"
                  flexDirection={{ base: "column", md: "row" }}
                  backgroundColor={"#F5F5F5"}
                >
                  <SmallFlexContainer
                    width={{ base: "100%", md: "49.14%" }}
                    backgroundColor={"#FFFFFF"}
                    alignItems={"center"}
                    padding={"20px"}
                    marginBottom={{ base: "20px", md: "0" }}
                  >
                    <HStack>
                      <CalendarImage width={"40px"} height="40px" />
                      <Heading headingLabel="Your Current Booking"></Heading>
                    </HStack>
                    <Form
                      updateBooking
                      formData={originalBooking}
                      disabled
                    ></Form>
                  </SmallFlexContainer>

                  <SmallFlexContainer
                    width={{ base: "100%", md: "49.14%" }}
                    backgroundColor={"#FFFFFF"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    padding={"20px"}
                  >
                    <SmallFlexContainer width={"92.92%"}>
                      <BookingDateForm
                        currentBookingDate={currentBookingDate?.toLocaleDateString()}
                        selectedSlot={selectedSlot?.slotTime}
                      />
                      <SmallFlexContainer marginTop={"20px"}>
                        <CustomButton
                          marginTop={"16px"}
                          onClick={() => {
                            setIsAmend(true);
                          }}
                          _hover={{
                            background: "blue.600",
                          }}
                          buttonLabel="Amend Booking"
                        ></CustomButton>

                        <CustomButton
                          ref={btnRef}
                          onClick={onOpen}
                          marginTop={"16px"}
                          backgroundColor={"#00E0FF"}
                          buttonLabel="Delete Booking"
                        ></CustomButton>
                      </SmallFlexContainer>
                    </SmallFlexContainer>
                  </SmallFlexContainer>
                </SmallFlexContainer>
              )}
            </>
          )}
        </SmallFlexContainer>
        <SidePanel
          isOpen={isOpen}
          onClose={onClose}
          btnRef={btnRef}
          title="Delete Booking"
          bodyText="Are you sure you want to delete this booking?"
          buttonLabel="Delete Booking"
          onClick={handleDelete}
          headingLabel="Delete Booking"
          alert
        />
      </SmallFlexContainer>
    </LargeContainer>
  );
}
